var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6", "offset-md": "3" } },
            [
              _c(
                "b-card",
                { staticClass: "py-4 px-5" },
                [
                  _vm.showContentPlaceholder
                    ? _c(
                        "content-placeholders",
                        [
                          _c("content-placeholders-img", {
                            staticStyle: { height: "350px" }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t("COMMON.TITLE"),
                                "label-for": "normalTitle"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "normalTitle",
                                  type: "text",
                                  placeholder: _vm.$t("FORMS.TITLE_PLACE")
                                },
                                model: {
                                  value: _vm.form.title,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "title", $$v)
                                  },
                                  expression: "form.title"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "required",
                              attrs: {
                                label: _vm.$t("FORMS.PROCESS_TYPE"),
                                "label-for": "basicText"
                              }
                            },
                            [
                              _c("b-form-select", {
                                class: {
                                  "is-invalid": _vm.$v.form.match_type.$error,
                                  "is-valid": !_vm.$v.form.match_type.$invalid
                                },
                                attrs: {
                                  plain: true,
                                  options: _vm.setOptions,
                                  placeholder: _vm.$t("FORMS.MATCH")
                                },
                                on: {
                                  input: function($event) {
                                    _vm.handleMatchSelect(),
                                      _vm.$v.form.match_type.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.form.match_type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "match_type", $$v)
                                  },
                                  expression: "form.match_type"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.match_type.required
                                ? _c("b-form-invalid-feedback", [
                                    _vm._v(_vm._s(_vm.$t("TEMPLATE.REQ_TYPE")))
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "6", lg: "8" } },
                                [
                                  _vm.canShowImgPreview
                                    ? _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "FORMS.FORCED_TEMPLATE"
                                            ),
                                            "label-for": "basicText"
                                          }
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              plain: true,
                                              options: _vm.templateOptions,
                                              placeholder: _vm.$t(
                                                "FORMS.TEMPLATE"
                                              )
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.handleTemplateSelect()
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.form.forced_template_doc_id,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "forced_template_doc_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.forced_template_doc_id"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "6", lg: "2" } },
                                [
                                  _c("zoom-center-transition", [
                                    _vm.canShowImgPreview
                                      ? _c("img", {
                                          staticClass: "shadow preview-image",
                                          attrs: { src: _vm.previewImageUrl }
                                        })
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isTriaging
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "required",
                                  attrs: {
                                    label: _vm.$t("FORMS.PROCESS_CATEGORIES"),
                                    "label-for": "ProcessCatgegories"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    attrs: {
                                      plain: true,
                                      options: _vm.process_categories
                                    },
                                    model: {
                                      value: _vm.form.process_categories,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "process_categories",
                                          $$v
                                        )
                                      },
                                      expression: "form.process_categories"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                    _c(
                      "div",
                      { staticClass: "saveButtonContainer" },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "saveButton",
                            attrs: {
                              type: "submit",
                              size: "sm",
                              variant: "secondary",
                              disabled: _vm.disableButton
                            },
                            on: { click: _vm.formUpload }
                          },
                          [
                            _vm.form.uploading
                              ? _c("i", {
                                  staticClass: "fa fa-spinner fa-spin mr-2",
                                  staticStyle: { "font-size": "18px" }
                                })
                              : _vm._e(),
                            _c("span", { ref: "uploadText" }, [
                              _vm._v(_vm._s(_vm.$t("COMMON.PROCESS")))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.file_length > 1 && _vm.form.title
                    ? _c("b-form-group", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checked,
                              expression: "checked"
                            }
                          ],
                          attrs: { type: "checkbox", id: "name_checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.checked)
                              ? _vm._i(_vm.checked, null) > -1
                              : _vm.checked
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.checked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checked = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checked = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "ml-1",
                            staticStyle: { color: "blue" },
                            attrs: { for: "name_checkbox" }
                          },
                          [_vm._v(_vm._s(_vm.$t("FORMS.USE_TITLE")))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "dropzone" } }, [
                    _vm._v(_vm._s(_vm.$t("FORMS.UPLOAD_MULTI_FORMS")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      ref: "zip-password-modal",
                      attrs: {
                        centered: "",
                        id: "zip-password",
                        title: "Enter Password",
                        "no-close-on-esc": "",
                        "no-close-on-backdrop": "",
                        "hide-header-close": "",
                        "ok-title": "submit"
                      },
                      on: {
                        cancel: _vm.cancel,
                        show: _vm.resetZipModal,
                        hidden: _vm.resetZipModal,
                        ok: _vm.handleZipPasswordSubmit
                      },
                      nativeOn: {
                        keydown: function($event) {
                          if (
                            !("button" in $event) &&
                            _vm._k($event.keyCode, "enter", 13, $event.key)
                          ) {
                            return null
                          }
                          _vm.handleZipPasswordSubmit($event)
                        }
                      }
                    },
                    [
                      _c(
                        "form",
                        {
                          ref: "zip-form",
                          attrs: { autocomplete: "off" },
                          on: {
                            submit: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              _vm.handleZipFormSubmit($event)
                            }
                          }
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                state: _vm.zipPasswordState,
                                label: _vm.currentFile.name,
                                "label-for": "password-input",
                                "invalid-feedback": _vm.$t(
                                  "COMMON.WRONG_PASSWORD"
                                )
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "password-input",
                                  type: "password",
                                  state: _vm.zipPasswordState,
                                  required: ""
                                },
                                model: {
                                  value: _vm.passwordInput,
                                  callback: function($$v) {
                                    _vm.passwordInput = $$v
                                  },
                                  expression: "passwordInput"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.canShowDropZone
                    ? _c("vueDropzone", {
                        ref: "formProcessDropZone",
                        attrs: { id: "dropzone", options: _vm.dropzoneOptions },
                        on: {
                          "vdropzone-file-added": _vm.onAddingFile,
                          "vdropzone-success": _vm.onSuccess,
                          "vdropzone-sending": _vm.sendingEvent,
                          "vdropzone-max-files-exceeded":
                            _vm.onExceedingMaxFiles,
                          "vdropzone-removed-file": _vm.onRemovingFile
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isDropzoneBlank
                    ? _c("p", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.$t("TEMPLATE.REQ_FILE")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isPdf
                    ? _c(
                        "div",
                        _vm._l(_vm.pdfsources, function(src, index) {
                          return _c("pdf", {
                            key: index,
                            ref: "pdfComponent",
                            refInFor: true,
                            staticStyle: { display: "none" },
                            attrs: { src: src },
                            on: {
                              password: _vm.pdfPasswordEvent,
                              error: _vm.pdfError,
                              "page-loaded": _vm.pdfLoaded
                            }
                          })
                        })
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d49bddb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d49bddb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/process/Upload.vue
// module id = 1141
// module chunks = 2